import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MUNILY_TITLE_PREVIEW_DEFAULTS, MunilyTitlePreviewSize } from './title-preview.types';

@Component({
  selector: 'common-title-preview',
  templateUrl: './title-preview.component.html',
  styleUrls: ['./title-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitlePreviewComponent implements OnChanges {
  @Input() value: string = MUNILY_TITLE_PREVIEW_DEFAULTS.value;
  @Input() showEditIcon: boolean = MUNILY_TITLE_PREVIEW_DEFAULTS.showEditIcon;
  @Input() size: MunilyTitlePreviewSize = MUNILY_TITLE_PREVIEW_DEFAULTS.size;

  @Output() edit = new EventEmitter<void>();

  public containerClasses: string[] = [];

  constructor() {
    this.syncContainerClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size']) {
      this.syncContainerClasses();
    }
  }

  onEdit(): void {
    this.edit.emit();
  }

  private syncContainerClasses(): void {
    const next: string[] = [];
    if (this.size === 'large') next.push('munily-title-preview--large');
    if (this.size === 'medium') next.push('munily-title-preview--medium');
    if (this.size === 'small') next.push('munily-title-preview--small');
    this.containerClasses = next;
  }
}
